import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import SuspendAccountMain from './SuspendAccountMain';
import SuspendAccountBlockData from '../../../Models/Content/SuspendAccountBlockData';

export default class SuspendAccountBlock extends EpiComponent<SuspendAccountBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <SuspendAccountMain iContent={this.props.data} context={this.getContext()} />;
  }
}
